{
    "name": "frontend-app",
    "version": "1.9.47-1",
    "scripts": {
        "ng": "ng",
        "start": "ng serve",
        "build": "npm run icons-converter && node srcipts/patch.js && ng build --configuration production",
        "build:stats": "npm run icons-converter && node srcipts/patch.js && ng build --configuration production --stats-json",
        "test": "ng test",
        "lint": "ng lint",
        "e2e": "ng e2e",
        "prerender": "ng run hyper-wallet:prerender",
        "icons-converter": "node srcipts/iconsSymbolsConverter.js",
        "postbuild": "node srcipts/update-version.js",
        "analyze": "webpack-bundle-analyzer ./dist/hyper-wallet/browser/stats.json"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^17.1.2",
        "@angular/cdk": "^17.0.0",
        "@angular/common": "^17.1.2",
        "@angular/compiler": "^17.1.2",
        "@angular/core": "^17.1.2",
        "@angular/forms": "^17.1.2",
        "@angular/platform-browser": "^17.1.2",
        "@angular/platform-browser-dynamic": "^17.1.2",
        "@angular/router": "^17.1.2",
        "@angular/service-worker": "^17.1.2",
        "@ethers-ext/signer-ledger": "6.0.0-beta.1",
        "@ledgerhq/hw-transport-webusb": "^6.28.4",
        "@lifi/sdk": "^3.2.3",
        "@metamask/eth-sig-util": "^5.0.2",
        "@mojs/core": "1.1.0",
        "@ngx-translate/core": "^15.0.0",
        "@ngx-translate/http-loader": "^7.0.0",
        "@opengsn/provider": "^2.2.6",
        "@pancakeswap/sdk": "^2.4.5",
        "@simplewebauthn/browser": "^13.1.0",
        "@uniswap/sdk": "^3.0.3",
        "@walletconnect/client": "^1.6.4",
        "@walletconnect/core": "^2.8.5",
        "@walletconnect/utils": "^2.8.5",
        "@walletconnect/web3-provider": "^1.7.7",
        "@walletconnect/web3wallet": "^1.8.5",
        "assert": "^2.0.0",
        "browser-crypto": "^1.4.0",
        "browserify-zlib": "^0.2.0",
        "buffer": "^6.0.3",
        "crypto-browserify": "^3.12.0",
        "crypto-js": "^4.0.0",
        "ethers": "6.11.1",
        "https-browserify": "^1.0.0",
        "moment": "^2.29.1",
        "ngx-indexed-db": "^16.0.0",
        "os-browserify": "^0.3.0",
        "pbkdf2": "3.1.2",
        "path-browserify": "^1.0.1",
        "qr-scanner": "^1.4.2",
        "quickswap-sdk": "^3.0.8",
        "rxjs": "~7.8.0",
        "sha3": "^2.1.3",
        "sharp": "^0.31.3",
        "stream-browserify": "^3.0.0",
        "stream-http": "^3.2.0",
        "tslib": "^2.0.0",
        "url": "^0.11.0",
        "zone.js": "~0.14.3"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^17.1.2",
        "@angular/cli": "^17.1.2",
        "@angular/compiler-cli": "^17.1.2",
        "@simplewebauthn/typescript-types": "^7.0.0",
        "@types/jasmine": "~3.6.0",
        "@types/jasminewd2": "~2.0.3",
        "@types/node": "^18.13.0",
        "codelyzer": "^6.0.0",
        "jasmine-core": "~3.8.0",
        "jasmine-spec-reporter": "~5.0.0",
        "karma": "~6.4.1",
        "karma-chrome-launcher": "~3.1.0",
        "karma-coverage-istanbul-reporter": "~3.0.2",
        "karma-jasmine": "~4.0.0",
        "karma-jasmine-html-reporter": "^1.5.0",
        "protractor": "~7.0.0",
        "replace-in-file": "^6.1.0",
        "ts-node": "~8.3.0",
        "tslint": "~6.1.0",
        "typescript": "~5.3.3",
        "webpack-bundle-analyzer": "^4.10.1"
    },
    "browser": {
        "crypto": false,
        "http": false,
        "https": false,
        "os": false,
        "stream": false,
        "zlib": false,
        "path": false,
        "fs": false
    },
    "engines": {
        "npm": ">=8.11.0",
        "node": ">=16.16.0"
    }
}
